// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"AN-z","upvoteIcon":"BN-z","downvoteIcon":"CN-z","feedbackIcon":"DN-z"};